
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"612","height":"792","viewBox":"0 70 612 662"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M92.182 736.362C41.271 736.362 0 695.092 0 644.181V231.69c0-50.91 41.271-92.181 92.182-92.181h42.786c4.285-47.337 43.858-83.655 91.387-83.871h233.049a25.973 25.973 0 0118.437 7.544l126.586 129.934a22.692 22.692 0 017.545 17.614v349.58c0 50.911-41.271 92.182-92.182 92.182h-42.786c-4.284 47.331-43.85 83.647-91.373 83.871H92.182zM50.303 231.69v412.491c.016 23.125 18.754 41.87 41.879 41.894h293.421c19.939.019 37.135-14.005 41.127-33.54H226.355c-50.91 0-92.181-41.271-92.181-92.182V189.769H92.182c-23.14.015-41.887 18.782-41.879 41.921zm134.06-83.871v412.49c0 23.153 18.769 41.922 41.921 41.922h293.478c23.147-.008 41.907-18.774 41.907-41.922V241.745h-69.562c-32.41 0-58.685-26.274-58.685-58.685v-77.12H226.369c-23.152-.047-41.959 18.684-42.006 41.836v.043zm299.236 35.213a7.545 7.545 0 008.381 8.382h41.127l-49.395-50.274-.113 41.892zM217.974 474l78.794-77.135c8.447-8.61 21.815-10.014 31.866-3.347l53.65 36.873 45.268-48.629v-44.446h52.813a33.55 33.55 0 0118.436 6.708 22.687 22.687 0 016.708 18.436l-1.673 53.649-37.724-1.673-61.194 66.229c-8.858 8.449-22.312 9.832-32.703 3.361l-54.486-36.873-63.705 62.868L217.974 474z"}})])
          )
        }
      }
    